import React from 'react'
import { inject, observer } from 'mobx-react'
import { Spinner } from 'react-bootstrap'
import { EditArticleComment } from './EditArticleComment'
import { StyledCard, StyledList } from './StyledDetailCard'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { formatedDate } from '../../../utils/formatedDate'
import { PdfButton } from '../../Buttons/PdfButton'
import { colors } from '../../../styles/colors'
import styled from 'styled-components';

const StyledDocumentWrapper = styled.a`
    min-height: 48px;
    color: ${colors.gray4};
    small {
        color: ${colors.gray3};
    }
    display: flex;
    align-items: center;
    margin: 5px 5px 5px 0 ;
    cursor: pointer;
`

const GeneralInfoCard = inject('inventoryStore', 'uiStore')(observer(props => {
    const { inventoryStore, uiStore } = props
    const { t } = useTranslation()

    const dataArray = (articleDetails) => {
        return (
            [
                {
                    label: t('articles'),
                    value: articleDetails.article.displayName
                },
                {
                    label: t('inventory:articleNr'),
                    value: articleDetails.article.articleNumber
                },
                {
                    label: t('productDetail:expirationDate'),
                    value: `${formatedDate(articleDetails.nextExpiryDate)} (${articleDetails.nextExpiryQuantity}x)`,
                    hide: !formatedDate(articleDetails.nextExpiryDate)
                },
                {
                    label: t('inventory:contingentAmount'),
                    value: articleDetails.articleAvailability && articleDetails.articleAvailability.currentAmount
                },
                {
                    label: t('inventory:maxAmount'),
                    value: articleDetails.articleAvailability && articleDetails.articleAvailability.maxAmount
                },
                {
                    label: t('comment'),
                    value: <EditArticleComment />,
                    hide: !uiStore.allowBPArticleComment
                }
            ])
    }

    return (
        <StyledCard>

            {(!inventoryStore.articleDetails || !uiStore.dashboard || inventoryStore.articleDetailsIsLoading)
                ? <div className="d-flex align-items-center justify-content-center">< Spinner animation='border' variant='primary' /></div >
                : <>
                    <div className="d-flex justify-content-between align-items-start"><h1>{t('inventory:generalInfos')}</h1><Link className="btn btn-outline-secondary btn-details " to={`/articleCatalog/article/${inventoryStore.articleDetails.article.id}`}>{t("inventory:goToArticle")}</Link></div>
                    <StyledList>
                        {dataArray(inventoryStore.articleDetails).map((listItem, idx) =>
                            listItem.hide
                                ? null
                                : <li key={`${idx} ${listItem.label}`}>
                                    <div className="label">{listItem.label}</div>
                                    <div className="value" >{listItem.value}</div>
                                </li>
                        )}
                    </StyledList>
                    {inventoryStore.articleDetails.maintenanceCheck?.url && (
                        <>
                            <StyledDocumentWrapper href={inventoryStore.articleDetails.maintenanceCheck.url} download={inventoryStore.articleDetails.maintenanceCheck.name} filename={inventoryStore.articleDetails.maintenanceCheck.name} target="_blank">
                                <PdfButton
                                    variant="secondary"
                                    buttonText={t("documents:maintenanceCheckDoc")}
                                    className="subheader__button"
                                />
                            </StyledDocumentWrapper>
                        </>
                    )}
                </>
            }
        </StyledCard >
    )
}))

export default GeneralInfoCard
